<template>
  <div>
    <HeaderInstaller
      :arrow="true"
      title="Aplicadores >> Configurações"
      text="Adicione mais especialidades e gerencie as configurações dos aplicadores IMPRIMAX."
      @voltar="voltar('installers')"
      :haveAction="false"
    />

    <v-container style="max-width: unset" class="px-8">
      <v-tabs class="px-0" background-color="#ECEEF1" grow height="55" hide-slider>
        <v-tab active-class="active-tab" class="tab" @click="activeTab = 0">
          <span>Especialidades</span>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="activeTab">
        <v-tab-item :value="0" style="max-width: unset" class="pa-3 pt-2">
          <InstallerSpecialties :key="categoryKey" />
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </div>
</template>

<style scoped>
.active-tab {
  background: #2d3038;
  color: #ffffff !important;
}
.tab {
  font-weight: bold;
  font-size: 16px;
  line-height: 27px;
  text-align: center;
  letter-spacing: 0.15px;
  color: #9c9c9c;
}

.main-title {
  font-weight: bold;
  font-size: 30px;
  line-height: 35px;

  color: #000000;
}

.main-subtitle {
  font-weight: normal;
  font-size: 18px;
  line-height: 21px;
  color: #5f6368;
}
.item {
  background: #424242 !important;
}

.item span {
  font-size: 1.05rem;
  color: #fff;
}

.back {
  background: #e9e9e9 !important;
  max-width: unset;
}

.filterAutocomplete {
  box-sizing: border-box;
  border-radius: 8px;
  width: 100%;
}

.table-button {
  font-weight: bold;
  transition: 300ms;
}

.table-button:hover {
  background: #2d3038;
  color: white !important;
}

.table-button:focus {
  background: #444854;
  color: white !important;
}

.config {
  background-color: #ffffff !important;
  border: 1px solid #2d3038 !important;
  box-sizing: border-box;
  border-radius: 10px;
  height: 50px;
}

@media (max-width: 330px) {
  .v-menu__content {
    left: 15px !important;
    max-width: unset;
  }
}

@media (max-width: 860px) {
  .table-header {
    display: none;
  }
}
</style>

<script>
import ApiService from "../../../../services/ApiService";
import HeaderInstaller from "../components/HeaderInstaller.vue";
import InstallerSpecialties from "./components/InstallerSpecialties.vue";

import Vue from "vue";

export default {
  data: () => ({
    attributeGroupKey: 0,
    attributeKey: 0,
    categoryKey: 0,
    currentAttribute: {},
    currentCategory: {},
    currentAttributesGroups: {},
    categories: [],
    attributes: [],
    attributesGroup: [],
    closeNoLoading: false,
    editDialog: false,
    dialogKey: false,
    loading: false,
    isLoading: false,
    message: "",
    activeTab: 0,
    page: 1,
    totalPages: 1,
    pageSize: 15,
    sizes: [15, 30, 90, 180],
    apiService: new ApiService(),
    filter: {
      page: 1,
      pageSize: 15,
    },
  }),

  async created() {},

  components: {
    HeaderInstaller,
    InstallerSpecialties,
  },

  methods: {
    filterTable() {
      this.filter.pageSize = this.pageSize;
      this.filter.page = this.page;
    },

    voltar(rota) {
      this.$router.push("/" + rota);
    },
  },

  watch: {
    pageSize() {
      this.filter.pageSize = this.pageSize;
      this.updateTable();
    },

    page() {
      this.filter.page = this.page;
      this.updateTable();
    },
  },
};
</script>
